module.exports = __webpack_public_path__ + "img/pop.8cf3678b.png";